import { FC } from 'react';
import IconSvg from './assets/icons/72/userAccountLogin.svg';
import IconSmallSvg from './assets/icons/48/userAccountLoginSmall.svg';

const Icon: FC<{ size?: 'large' | 'small' }> = ({ size = 'large' }) => {
  return <img alt="uuser-account-login" src={size === 'large' ? IconSvg : IconSmallSvg} />;
};

export default Icon;
